<template>
    <div>
        <div class="loading" :style="cssStyle">
            <loader color='#c9c9c9' size="5px"></loader>
        </div>
    </div>
</template>

<script>
    import loader from 'vue-spinner/src/PulseLoader.vue'

    export default {
        name: 'Loading',
        components: { loader },
        props: {
            height: { type: String, required: true }
        },
        computed: {
            cssStyle: function () {
                return "height: " + this.height + ";";
            }
        }
    }
</script>
